import { questions } from "../../BehaviourAnalysis";
import { AnswerContainer, AnswerDot, AnswerGraphic, AnswerTitle, Content } from "./Answer.style";

interface Props {
    answer: string;
    isChecked: boolean;
    onClick: () => void;
}

export default function Answer({answer, isChecked = false, onClick}: Props) {
    return (
       <AnswerContainer onClick={onClick} isSelected={isChecked}>
            <AnswerGraphic>
                <AnswerDot isSelected={isChecked} />
            </AnswerGraphic>
            <AnswerTitle isSelected={isChecked}>
                <Content>{answer}</Content>
            </AnswerTitle>
       </AnswerContainer>
    );
}